import {
  put, takeEvery, all, select,
} from 'redux-saga/effects';
import { exception } from 'circe/logger';
import { startLoading, doneLoading } from 'domain/layout/actions';
import {
  init, fetch, fetched, markAsPaid, download,
} from './actions';
import { fetchStatements, markAsPaid as markAsPaidAPI, download as downloadAPI } from './apis';
import { getFromDate, getToDate } from './selectors';

function* doInit() {}

function* doFetch(action) {
  const {
    payload: { from, to },
  } = action;

  const filters = {
    from,
    to,
  };

  yield put(
    startLoading('GET_STATEMENTS', {
      urls: ['/credit-terms'],
    }),
  );

  // TODO DOMAIN HARD CODING
  try {
    const data = yield fetchStatements(filters);
    yield put(fetched(data));
  } catch (e) {
    throw new Error('Unable to get statements.');
  }
  yield put(doneLoading('GET_STATEMENTS'));
}

function* doMarkAsPaid(action) {
  const { payload: params = { refId, trxId } } = action;

  const state = yield select();
  yield put(
    startLoading('MARK_STATEMENT_AS_PAID', {
      urls: ['/credit-terms'],
    }),
  );
  try {
    const resp = yield markAsPaidAPI(params);
    if (resp) {
      if (!resp.success) {
        alert(resp.message);
        throw new Error(`Unable to mark statement as paid ${params.refId} ${message}`);
      }
    } else {
      alert('We were unable to perform your request, Our team were notified about it');
      exception(new Error(`Unable to mark statement as paid ${params.refId} ${message}`), {
        timeout: 'Timeout',
      });
    }
  } catch (e) {
    exception(e);
  }
  const from = getFromDate(state);
  const to = getToDate(state);
  yield put(fetch(from, to));
  yield put(doneLoading('MARK_STATEMENT_AS_PAID'));
}

function* doDownload(action) {
  const { payload: params = { refId } } = action;
  try {
    const resp = yield downloadAPI(params);
    if (!resp) {
      throw new Error('Unable to download payable');
    }
    yield window.open(resp);
  } catch (e) {
    throw new Error('Unable to get statements.');
  }
}
function* watcher() {
  yield all([
    takeEvery(init().type, doInit),
    takeEvery(fetch().type, doFetch),
    takeEvery(markAsPaid().type, doMarkAsPaid),
    takeEvery(download().type, doDownload),
  ]);
}

export default watcher;
